import axios from "axios";
import { unsubscribe } from "@/firebase/fcm";
import { storeAuthData } from "@/helper/storeAuth";
export default {
  async login({ commit }, credentials) {
    try {
      let { data } = (
        await axios.post(`login`, {
          phone: credentials.number,
          password: credentials.password,
        })
      ).data;
      if (data.type === "owner") {
        await storeAuthData(data);
        commit("SET_SUCCESS", true);
        commit("SET_LOGGED_IN", true);
      } else {
        commit("SET_ERRORS", {
          phone: ["بيانات الدخول غير صحيحه"],
        });
      }
    } catch (e) {
      commit("SET_MESSAGE", e.response.data.message);
      commit("SET_ERRORS", e.response.data.errors);
    }
  },

  async register({ commit }, registerData) {
    try {
      let { data } = await axios.post(`owner/register`, {
        ...registerData,
        password_confirmation: registerData.password,
      });
      await storeAuthData(data.data);
      commit("SET_SUCCESS", true);
      commit("SET_LOGGED_IN", true);
    } catch (e) {
      commit("SET_MESSAGE", e.response.data.message);
      commit("SET_ERRORS", e.response.data.errors);
      commit("SET_SUCCESS", false);
    }
  },

  async logout({ commit }) {
    commit("SET_LOGGED_IN", false);
    await unsubscribe();
    await axios.post("logout");
    await localStorage.clear();
    location.href = process.env.VUE_APP_LANDING_URL;
  },

  async forgetPassword({ commit }, credentials) {
    let response;
    try {
      response = await axios.post(`forget-password/reset`, {
        phone: credentials,
      });
      if (response.status == 204 || response.status == 200) {
        commit("SET_SUCCESS", true);
        commit("SET_MESSAGE", "");
        commit("SET_ERRORS", "");
      } else {
        commit("SET_SUCCESS", false);
        commit("SET_MESSAGE", response.data.message);
        commit("SET_ERRORS", response.data.errors);
      }
    } catch (e) {
      commit("SET_SUCCESS", false);
      commit("SET_MESSAGE", e.response.data.message);
      commit("SET_ERRORS", e.response.data.errors);
    }
  },

  async forgetUpdatePassword({ commit }, credentials) {
    try {
      await axios.post(`forget-password/update`, credentials);
      commit("SET_SUCCESS", true);
      commit("SET_MESSAGE", "تم تغير كلمة المرور بنجاح");
      commit("SET_ERRORS", "");
    } catch (e) {
      commit("SET_SUCCESS", false);
      commit("SET_MESSAGE", e.response.data.message);
      commit("SET_ERRORS", e.response.data.errors);
    }
  },
};
